import React, { useState } from 'react';
import { Controller } from 'react-hook-form';
import { TextareaAutosize } from '@mui/material';

export const FormInputTextArea = ({
  name,
  control,
  disabled,
  label,
  placeholder,
  style,
  minRows,
  maxRows,
  rows,
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const getBorderColor = () => {
    if (isFocused) return '#0F7F85';
    if (isHovered) return 'rgba(0, 0, 0, 0.87)';
    return 'rgba(133, 133, 133, 0.5)';
  };

  const baseStyle = {
    ...style,
    borderColor: getBorderColor(),
    borderWidth: isFocused ? '2px' : '1px',
    outline: 'none',
    transition: 'border-color 0.2s ease',
  };

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value } }) => (
        // TextareaAutosize는 순수 textarea 라 MUI 전용 prop(error/label/fullWidth 등)을 넘기면 DOM 경고 발생
        <TextareaAutosize
          style={baseStyle}
          placeholder={placeholder}
          onChange={onChange}
          value={value ?? ''}
          maxRows={maxRows}
          rows={rows}
          minRows={minRows}
          disabled={disabled}
          aria-label={label}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        />
      )}
    />
  );
};
